export {default as wordcloud} from './src/Wordcloud';



// WEBPACK FOOTER //
// ./~/vega-wordcloud/index.js